<template lang="pug">
.camp-intro
  .intro-header
    h1 營地搜尋工具介紹
    p.subtitle 一個整合多平台營地資訊的搜尋工具

  .intro-content
    section.features
      h2 支援平台
      .platform-list
        .platform-item
          i.el-icon-house
          span iCamping
        .platform-item
          i.el-icon-office-building
          span EasyCamp
        .platform-item
          i.el-icon-school
          span TWCamping

    section.features
      h2 主要功能
      .feature-list
        .feature-item
          i.el-icon-search
          .feature-content
            h3 跨平台搜尋
            p 整合多個營地平台的資料，讓您一次搜尋所有平台的營地資訊
        .feature-item
          i.el-icon-info
          .feature-content
            h3 詳細資訊
            p 提供完整的營地資訊，包括海拔、地址、價格等詳細資料
        .feature-item
          i.el-icon-video-camera
          .feature-content
            h3 影片整合
            p 整合 YouTube 影片，讓您可以直接觀看營地相關影片
        .feature-item
          i.el-icon-collection-tag
          .feature-content
            h3 標籤系統
            p 透過標籤系統，快速找到符合您需求的營地
        .feature-item
          i.el-icon-map-location
          .feature-content
            h3 Google Maps 整合
            p 一鍵開啟 Google Maps，輕鬆找到營地位置

    section.usage
      h2 使用方式
      ol.usage-steps
        li 在搜尋欄位輸入關鍵字（如：營地名稱、地區等）
        li 選擇地區和城市進行篩選
        li 可選擇是否使用海拔篩選
        li 點擊搜尋按鈕開始搜尋
        li 在搜尋結果中點擊「查看詳情」可查看更多資訊
        li 點擊營地名稱或來源可直接前往該平台查看完整資訊

</template>

<script>
export default {
  name: 'CampIntro'
}
</script>

<style scoped>
.camp-intro {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.intro-header {
  text-align: center;
  margin-bottom: 40px;
}

.intro-header h1 {
  font-size: 32px;
  color: #303133;
  margin-bottom: 16px;
}

.subtitle {
  font-size: 18px;
  color: #606266;
}

.intro-content {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

section {
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

h2 {
  font-size: 24px;
  color: #303133;
  margin-bottom: 24px;
  padding-bottom: 12px;
  border-bottom: 2px solid #409EFF;
}

.platform-list {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 20px;
}

.platform-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.platform-item i {
  font-size: 32px;
  color: #409EFF;
}

.platform-item span {
  font-size: 18px;
  color: #606266;
}

.feature-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
}

.feature-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.feature-item i {
  font-size: 24px;
  color: #409EFF;
  margin-top: 4px;
}

.feature-content h3 {
  font-size: 18px;
  color: #303133;
  margin-bottom: 8px;
}

.feature-content p {
  color: #606266;
  line-height: 1.6;
}

.usage-steps {
  padding-left: 20px;
  color: #606266;
}

.usage-steps li {
  margin-bottom: 12px;
  line-height: 1.6;
}

@media (max-width: 768px) {
  .camp-intro {
    padding: 16px;
  }

  .intro-header h1 {
    font-size: 24px;
  }

  .subtitle {
    font-size: 16px;
  }

  section {
    padding: 16px;
  }

  h2 {
    font-size: 20px;
  }

  .feature-list {
    grid-template-columns: 1fr;
  }
}
</style> 